/**
 * Created by toomasp on 10.08.2015.
 */
"use strict";

let template = require('./pager.html');

export default ["config", "pagerFactory", (config, pagerFactory) => {
    class PagerDirective {
        restrict = 'A';
        scope = {
            pager: '=pager'
        };
        replace = true;
        template = template;

        link = function (scope, element, attr, ctrl) {
            scope.char = {
                back: '«',
                forward: '»',
                dash: '–'
            };
            _.extend(scope.pager, pagerFactory.createPager(scope.pager.pageSize));
        }
    }

    return new PagerDirective();
}];


// WEBPACK FOOTER //
// ./src/ui/core/common/directives/widget/table/pager.directive.js